<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Refund Payment
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <b-form-group v-if="!paymentHasPartialRefund" horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('isPartialRefund')"
                          :invalid-feedback="errorForField('isPartialRefund')"
                          label="Full Refund"
                          label-class="text-right">
              <b-form-radio-group :disabled="paymentHasPartialRefund" v-model="isFullRefund" class="pt-2" :options="yesNoOptions"/>
            </b-form-group>
            <b-form-group id="amountFieldGroup"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          invalid-feedback="Amount is required"
                          :description="amountDescription"
                          label="Amount"
                          label-for="amountField"
                          label-class="text-right">
              <b-input-group prepend="$">
                <b-form-input :disabled="isFullRefund" id="amountField" v-model="partialRefund.amount"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="processRefund()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>Process
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import api from '../services/api'
  import ErrorsMixin from '../mixins/ErrorsMixin'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'RefundModal',

    components: {},

    mixins: [ErrorsMixin, AnalyticsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      payment: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        isFullRefund: true,
        partialRefund: {
          amount: 0
        },
        isSaving: false,
        yesNoOptions: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ]
      }
    },

    watch: {
      payment (newValue, oldValue) {
        if (newValue) {
          this.partialRefund.amount = this.formatNumber(newValue.refundableAmount)
          if (newValue.refundableAmount < newValue.amount) {
            this.isFullRefund = false
          } else {
            this.isFullRefund = true
          }
        }
      },

      visible (newValue) {
        if (newValue) {
          this.partialRefund.amount = this.formatNumber(this.$props.payment.refundableAmount)
        } else {
          this.clearAllErrors()
        }
      }
    },

    computed: {
      amountDescription () {
        if (!this.isFullRefund) {
          return 'Total payment after refund would be ' + this.formatNumber(this.$props.payment.refundableAmount - this.partialRefund.amount)
        }

        return ''
      },

      paymentHasPartialRefund () {
        return this.$props.payment.refundableAmount < this.$props.payment.amount
      }
    },

    methods: {
      formatNumber (number) {
        if (number) {
          return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }

        return '0.00'
      },

      processRefund () {
        if (this.isSaving) {
          return
        }
        this.clearAllErrors()
        this.isSaving = true

        let endpoint = 'Refund'
        if (!this.isFullRefund) {
          endpoint = 'PartialRefund'
        }
        api.post('/Dashboard/' + endpoint + '/' + this.payment.organizationPatientPaymentId, this.partialRefund).then(response => {
          this.trackEvent(this.$options.name, 'Save', 'ResponseTime', response.config.requestDuration)

          if (response.data.creditCardPaymentResult !== 'Success') {
            this.addErrorForField('exception', response.data.hostResponseMessage)
          } else {
            const payment = response.data
            this.$emit('refundProcessed', payment)
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'SaveError', error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>

.btn-hh-white {
  background-color: white;
  color: #ff4f00;
  border-color: #ff4f00;
}

.btn-hh-orange {
  color: white;
  background-color: #ff4f00 !important;
  border-color: #ff4f00;
}

.btn:focus {
  outline: none;
  box-shadow: none;
}

</style>
